<template>
    <billing-layout>      
        <div class="container-fluid">
            <div class="row">
            <div class="col-12">
                <div class="card" id="card-invoice">
                    <div class="card-header" style="padding-left: 0;">
                        <div class="row">
                          <div class="col-md-6">
                               <router-link :to="{name : 'InvoicesNew'}" class="btn btn-success"><i class="fas fa-plus"></i> Add Invoice</router-link>

                            </div>
                            <div class="col-md-6">
                             <div class="row">
                                 <div class="col-md-8">
                                    <input type="text" class="form-control" placeholder="Search" v-model="inputFilter" v-on:keyup="searchFilter">
                                 </div>
                                 <div class="col-md-2">
                                    <div class="basic_dropdown" v-click-outside="hideBtnstatus">
                                      <button class="btn-status"  @click="btnstatus()">Status <i class="fas fa-caret-down"></i></button>
                                      <ul class="reset dropdStatus" v-if="statusdropd">
                                        <li>
                                          <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" id="check12" @click="checkAll()" v-model="isCheckAll">
                                            <label class="custom-control-label" for="check12"><b>All</b></label>
                                          </div>
                                        </li>
                                        <li v-for="(item,index) in statusdata" :key="index">
                                          <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" :id="index" v-bind:value="item.value" v-model="statuslist" @change="searchFilter">
                                            <label class="custom-control-label" :for="index">{{item.name}}</label>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                 </div>
                             </div>
                            </div>
                        </div>
                    </div>
                <div class="row">
                <div class="col-md-12">
                <Loader v-if="isLoading"></Loader>
<div class="contenedor-invoice" v-else>
<table class="table table-striped table-bordered table-hover" v-if="InvoicesList.length > 0" id="invoList">
  <thead>
    <tr>
      <th scope="col">Inv #</th>
      <th scope="col">Date</th>
      <th scope="col">Due Date</th>
      <th scope="col">Customer</th>
      <th scope="col">Name</th>
      <th scope="col" style="text-align:right">Total</th>
      <th scope="col" style="text-align:right">Tax</th>
      <th scope="col" style="text-align:right">Balance</th>
      <th scope="col" style="text-align:center">Status</th>
      <th scope="col" style="text-align:center">Rec</th>
      <th scope="col" style="text-align:center">Email</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="item in InvoicesList" :key="item.id">
      <td scope="row">{{item.numdoc}} <NotesAdmin type='Invoice' :id="item.id" sTxt="display:none;" :btnNotes="item.notes" style="float:right;"/></td>
      <td>{{item.fecdoc}} </td>
      <td>{{item.fecdue}} </td>
      <td>{{item.firstname}} {{item.lastname}}<br><span style="color:#a9a9a9">{{item.bussinesname}}</span></td>
      <td>{{item.invoicename}}</td>
      <td style="text-align:right">${{item.total | formatMoney  }}</td>
      <td style="text-align:right"><span v-if="item.tax !== 0">${{item.tax | formatMoney}}</span><span v-else>--</span></td>
      <td style="text-align:right">${{item.balance | formatMoney}}</td>
      <td style="text-align:center">
          <span v-if="item.idxstatus == 1" class="badge badge-secondary" style="background-color:#f89406">Pending</span>
          <span v-else-if="item.idxstatus == 2" class="badge badge-primary">Partially Paid</span>
          <span v-else-if="item.idxstatus == 3" class="badge badge-success">Paid</span>
          <span v-else-if="item.idxstatus == 4" class="badge badge-primary" style="background-color:#e90404">Overdue</span>
          <span v-else-if="item.idxstatus == 5" class="badge badge-danger" style="background-color:#b94a48">Void</span>
      </td>
      <td style="text-align:center">
          <span v-if="item.rec == 1" class="badge badge-success">Rec</span>
      </td>
      <td style="text-align:center"><button @click="actionEmail(item.id,item.email,item.numdoc)" style="border:0;background: transparent;cursor:pointer;font-size:13px;">{{item.numemaienv}} <i class="fas fa-envelope" style="color:#f89406; font-size:18px;"></i></button></td>
      <td>
          <span class="cdropdown">
            <button><span>Actions</span></button>
            <label>
            <input type="checkbox">
            <ul>
                <li @click="actionPdf(item.id)"><button><i class="fas fa-file-pdf"></i> Open PDF</button></li>
                <li @click="actionPDFforEnvelope(item.id)"><button><i class="fas fa-file-pdf"></i> Open PDF for Envelope</button></li>
                <li @click="actionPrint(item.id)"><button><i class="fas fa-print"></i> ePrint</button> </li>
                <li @click="actionPay(item.id,item.numdoc,item.total,item.customer_id,item.firstname,item.lastname,item.bussinesname,item.balance)"><button><i class="fas fa-dollar-sign"></i> Make a Payment</button> </li>
                <li @click="statement(item.id)"><button><i class="fas fa-file-invoice-dollar"></i> Statement</button> </li>
                <li @click="actionDuplicate(item.id)" ><button><i class="fas fa-copy"></i> Duplicate</button> </li>
                <li @click="convertRecurring(item.id)"><button><i class="fas fa-file-alt"></i> Convert to Recurring Invoices</button> </li>
                <li @click="actionEdit(item.id)" v-if="item.idxstatus !== 2 && item.idxstatus !== 3 && item.idxstatus !== 5"><button><i class="fas fa-edit"></i> Edit</button></li>
                <li @click="actionVoid(item.id)" v-if="item.idxstatus !== 2 && item.idxstatus !== 3 && item.idxstatus !== 5"><button><i class="fas fa-trash-alt"></i> Void</button></li>
                <li @click="MetDeleteInvoice(item.id)" v-if="item.idxstatus !== 2 && item.idxstatus !== 3 && item.idxstatus !== 5"><button><i class="fas fa-times"></i> Delete</button> </li>
            </ul>
            </label>
        </span>
      </td>
    </tr>
  
  </tbody>
</table>
<div class="text-center d-block w-100 p20" v-else-if="InvoicesList.length==0 && isFilter==true">
  
    <div class="text-center" style="padding:30px;">No record</div>
</div>
<div class="text-center d-block w-100 p20" v-else>
  <div class="text-center" style="padding:30px;"> <span >Its time to create your first Invoice!</span><br>
  <router-link :to="{name : 'InvoicesNew'}" class="btn btn-success " style="margin-top:7px">Create New Invoice</router-link>
  </div>
</div>
    </div>            
                    </div>


                    </div>
                </div>
              </div>
            </div>
        </div>

 <modal name="modal-setting" height="auto" @before-close="ClosedModal">
    <div class="card">
    <component :is="SettingBox" :items="DataMail"></component>
    </div>
</modal>
<modal name="modal-payment" height="auto" @before-close="ClosedModal">
    <div class="card">
      <div class="card-header">
        ADD PAYMENT <span style="color:#fff; background-color:#4CAF50;padding: 3px;border-radius: 3px;"> INV #{{form.numdoc}}</span><span style="padding-left:5px;font-size: 16px;">{{previewcustomername}} {{previewcustomerlastname}} - {{previewcustomerbusinessname}}</span>
        <button @click="closeModal" class="closeIcon"><span></span></button>
      </div>
       <form @submit.prevent="savePayment" enctype="multipart/form-data" id="form1">
      <div class="card-body">
      <div class="bgloading" v-show="isLoading"><Loader></Loader></div>
      <div style="display:flex;color:#fff;margin-bottom: 10px;">
      <div style="background-color:#87c37b;width: 50%;text-align:right;padding: 10px;">Total: <span style="font-size: 19px;">${{previewtotal | formatMoney}}</span></div>
      <div style="background-color:#737373;width: 50%;padding: 10px;">Balance: <span style="font-size: 19px;">${{previewbalance | formatMoney}}</span> </div>
      </div>
      <div class="form-row">
                      <div class="form-group col-md-4">
                        <label >Pmt Method</label>
                        <model-select 
                        required
                        :options="PaymentMethodsList" 
                        v-model="form.method_id" 
                        class="metodos"
                        placeholder="Choose a Method"
                        >
                        </model-select>
                      </div>
                      <div class="form-group col-md-5">
                        <label for="inputCity">Ref #</label>
                        <input type="text" class="form-control" v-model="form.ref">
                      </div>
                      <div class="form-group col-md-3">
                        <label for="inputZip">Amount</label>
                        <div class="input-group"  >
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text" class="form-control" placeholder="0.00" required  v-model="form.price" @keyup="validP">
                          <span class="error" style="color:red;" v-if="form.vatError">{{form.vatErrorMsg}}</span>
                        </div>
                      </div>
                    </div>
                     <div class="form-group">
                      <label for="">Admin Notes</label>
                      <textarea class="form-control" rows="2"  v-model="form.memo"></textarea>
                    </div>
                    <div class="form-group">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="gridCheck"  v-model="form.send_invoice">
                        <label class="form-check-label" for="gridCheck">
                          Send Invoice/Payment notification mail to the client
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="gridCheck2"  v-model="form.send_img">
                        <label class="form-check-label" for="gridCheck2">
                          Send Image
                        </label>
                      </div>
                    </div>
                    <div class="form-group">
                      <input type="file" style="display:none;" ref="img1"  accept="image/*" @change="fileImg1">
                      <button type="button" class="btn btn-info" @click="$refs.img1.click()">Attachment 1</button>
                      <div v-if="Showimg1" style="margin-top:10px;">
                        <img v-bind:src="preview1" id="img1"  @click="$refs.img1.click()" style="width:100%; max-width:600px;width: 50px; ">
                      </div>
                    </div>
                    <div class="form-group">
                      <input type="file" style="display:none;" ref="img2" accept="image/*" @change="fileImg2">
                      <button type="button" class="btn btn-info" @click="$refs.img2.click()">Attachment 2</button>
                      <div v-if="Showimg2" style="margin-top:10px;">
                        <img v-bind:src="preview2" id="img2" @click="$refs.img2.click()" style="width:100%; max-width:600px;width: 50px;">
                      </div>
                    </div>
                    <div style="width: 100%; text-align: right; margin-top: 20px;">
                      <button type="button" class="btn btn-secundary btn-lg" style="margin-right: 10px;" @click="actionPayHide">
                        <i class="fas fa-times"></i> CANCEL
                      </button>
                      <button type="submit" class="btn btn-success btn-lg"  :disabled='isDisabled'>
                        <i class="fas fa-save"></i> SAVE
                      </button>
                    </div>
      </div>
      </form>
    </div>
</modal>
<notifications group="noti" position="top center">
</notifications>
    </billing-layout>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/shared/Loader'
import BillingLayout from '@/Layouts/Billing/BillingLayout'
import Taxes from '@/components/billing/setting/Taxes.vue';
import Terms from '@/components/billing/setting/Terms.vue';
import modalEmail from '@/components/billing/modalEmail'
import { ModelSelect } from 'vue-search-select'
import EventBus from '@/eventBus'
import NotesAdmin from '@/components/billing/NotesAdmin.vue';
import ClickOutside from 'vue-click-outside'
export default {
     name:'Invoices',
     components:{
            Loader,
            BillingLayout,
            Terms,
            Taxes,
            modalEmail,
            ModelSelect,
            NotesAdmin
    },
    
    data() {
        return{
            isLoading : false,
            showModal: false,
            SettingBox : '',
            InvoicesList : [],
            DataMail : {
                isLoading : false,
                idinv : null,
                IDitem : null, // numdoc
                email : null,
                EmailCheck : false,
                view : 'invoice',
            },
            emails : [],
            form: {
              id: null,
              numdoc : null,
              user_id: window.localuserdata,
              customer_id: null,
              invoice_id: '',
              fecha:  new Date().toISOString().slice(0,10),
              method_id: '',
              ref: null,
              price: null,
              memo: null,
              send_invoice: false,
              send_img: false,
              img1: null,
              img2: null,
              imgOld1: null,
              imgOld2: null,
              status: 1,
              ope: 'create',          
              vatError : false,
              vatErrorMsg : null,
          },
          editar: false,
          validimg1: false,
          validimg2: false,
          validimgOld1: false,
          validimgOld2: false,
          Showimg1: false,
          Showimg2: false,
          preview1: '',
          preview2: '',
          isDisabledPrice: true,
          PaymentMethodsList : [],
          totalinvoice: '',
          previewtotal : null,
          previewbalance : null,
          previewcustomername : null,
          previewcustomerlastname : null,
          previewcustomerbusinessname : null,
          inputFilter: '',
          OldInvoicesList: [],
          invStatus:0,
          isFilter: false,          
           isCheckAll: true,
           statusdata: [
             {'value' : '1','name' : 'Pending'},
             {'value' : '2','name' : 'Partially Paid'},
             {'value' : '3','name' : 'Paid'},
             {'value' : '4','name' : 'Overdue'},
             {'value' : '5','name' : 'Void'}
           ],
           statuslist: [1,2,3,4,5],
           statusdropd : false,
           paginador: 0,
        } 
    },
    created(){
      this.getInvoices();
      this.getMethods();
    },
   
    mounted(){
    },
    directives: {
      ClickOutside
    },
    methods:{
      closeModal(){
        this.$modal.hide('modal-payment')
        },
        abrirCanalEventBus(){
          let vm = this;
          EventBus.$on('invoice-email',(item)=>{
            this.emails =item; 
            vm.sendMailInvoice(item); 
          });
        },
        btnstatus(){
         this.statusdropd = !this.statusdropd;
        },
        hideBtnstatus(){
          this.statusdropd = false;
        },
        checkAll: function(){

          this.isCheckAll = !this.isCheckAll;
          this.statuslist = [];
          if(this.isCheckAll){
            for (var key in this.statusdata) {
              this.statuslist.push(this.statusdata[key].value);
            }
            this.searchFilter();
          }
        },
        updateCheckall: function(){
            if(this.statuslist.length == this.statusdata.length){
              this.isCheckAll = true;
            }else{
              this.isCheckAll = false;
            }
        },
        searchFilter(){
          if(this.inputFilter.length > 1 || this.statuslist.length > 0)
          {
            this.isLoading = true;
            console.log('searchFilter');
            window.billing.post('filterinvoice', 
              {
                user_id: window.localuserdata, 
                filter:this.inputFilter,
                status: this.statuslist,
                pag: this.paginador
              }
            ).then((response) => {
                  //console.log('filter ',response.data.result);
                  let listFilter = response.data.result;
                  
                  let e = listFilter;
                  let listOverdue = [];
                  let listStatus = [];
                  let soloFilter = [];
                    for (var i = 0; i < e.length; i++) {
                      let fecdoc= new Date(e[i].fecdoc).toDateString();
                      let fn= fecdoc.split(' ');
                      listFilter[i].fecdoc=fn[1]+' '+fn[2]+', '+fn[3];
                      let fecdue= new Date(e[i].fecdue).toDateString();
                      fn= fecdue.split(' ');
                      listFilter[i].fecdue=fn[1]+' '+fn[2]+', '+fn[3];
                      let f_a= new Date();
                      fecdue= new Date(e[i].fecdue);
                      
                      if(f_a > fecdue && e[i].idxstatus < 2 ){
                        listFilter[i].idxstatus = 4;
                        listOverdue.push(listFilter[i]);
                      }else{listStatus.push(listFilter[i]);}
                      if(this.statuslist.includes(''+listFilter[i].idxstatus+''))
                      {
                        soloFilter.push(listFilter[i]);
                      }
                    }
                    if(this.statuslist.length == 1 && this.statuslist.includes('4'))
                    {
                      this.InvoicesList= listOverdue;      
                    }
                    else if(this.statuslist.length > 0 && this.statuslist.length < 5 && this.statuslist.includes('4'))
                    {
                      this.InvoicesList= soloFilter;    
                    }
                    else if(this.statuslist.length > 0 && this.statuslist.length < 5 && !this.statuslist.includes('4'))
                    {
                      this.InvoicesList= listStatus;       
                    }
                    else{this.InvoicesList=listFilter;}
                  this.isFilter= true;
                  this.isLoading = false;
             }).catch((error) => {
                this.isLoading = false;
                console.log(error);
            });
          }
          else
          {
            //this.InvoicesList=this.OldInvoicesList;
            //this.isLoading = false;
            //this.isFilter= false;
            console.log('getInvoices');
            this.getInvoices();
          }
        },
        searchFilterPaginador(){
          if(this.paginador > 0)
          {
            this.searchFilter();
          }
          else
          {
            this.InvoicesList=this.OldInvoicesList;
            this.isLoading = false;
            this.isFilter= false;
          }
        },
        ClosedModal(){
            this.SettingBox =''
        },
        sendMailInvoice(item){          
          if(item.DataItem.send==1){
            item.DataItem.send=0;
            this.$modal.hide('modal-setting');
            this.SettingBox = '';
            //this.getInvoices();
            this.searchFilter();
            this.$notify({
              group: 'noti',
              title: 'Success',
              type: 'success',
              text: 'Send Mail!'
            });
            EventBus.$off('invoice-email');
          }
        },
        actionPay(id,numdoc,total,customer_id,cname,clname,cbname,balance){
            this.form.id = id
            this.form.invoice_id = id
            this.form.numdoc = numdoc
            this.totalinvoice = balance
            this.form.customer_id = customer_id
            this.previewcustomername = cname
            this.previewcustomerlastname = clname
            this.previewcustomerbusinessname = cbname
            this.previewtotal = total
            this.previewbalance = balance
            this.$modal.show('modal-payment');
        },
        actionPayHide(){
            this.$modal.hide('modal-payment');
        },  
        savePayment()
        {
          this.subirIMGs();
        },      
        subirIMGs(){
          let t = this;
          t.isLoading = true;
          let f = new FormData(); 
          let contIMG=0;
          let contDel=0;
          for (let i in t.form)
          {
            if(i == 'img1' && t.form[i] !== null  && t.validimg1 == true){
              contIMG++;
              let nom='img'+contIMG;
              f.append(nom, t.form[i], t.form[i].name);
            }
            if(i == 'img2' && t.form[i] !== null && t.validimg2 == true ){
              contIMG++;
              let nom='img'+contIMG;
              f.append(nom, t.form[i], t.form[i].name);
            }
            if(i == 'imgOld1' && t.form[i] !== null  && t.validimgOld1 == true){
              contDel++;
              let nom='imgOld'+contDel;
              f.append(nom, t.form[i]);
            }
            if(i == 'imgOld2' && t.form[i] !== null && t.validimgOld2 == true ){
              contDel++;
              let nom='imgOld'+contDel;
              f.append(nom, t.form[i]);
            }               
          }
          f.append('nombreIMG', 'img');
          f.append('contIMG', contIMG);
          f.append('delIMG', 'imgOld');
          f.append('contDel', contDel);
          f.append('folder', 'payments');
          f.append('org_id', window.localorgdata);
          window.master.post('upload', f)
          .then((response) => {
              let imgs = response.data.imgs;
              this.saveData(imgs)
          })
          .catch((error) => {
            this.isLoading = false;
            console.log(error);
          });
        },
        saveData(imgs){
          var self = this;
          self.isLoading = true;
          var f = new FormData();
          console.log(self.form);       
          for (let prop in self.form)
          {
            console.log(prop, self.form[prop])          
            if(prop == 'img1' && self.form[prop] !== null && self.validimg1 == true ){
              f.append(prop, imgs[1]);
            }
            else if(prop == 'img2' && self.form[prop] !== null && self.validimg2 == true && self.validimg1 == true){
              f.append(prop, imgs[2]);
            }
            else if(prop == 'img2' && self.form[prop] !== null && self.validimg2 == true && self.validimg1 == false){
              f.append(prop, imgs[1]);
            }
            else if(prop == 'send_invoice'){
              if(self.form[prop]){self.form[prop]=1;}else{self.form[prop]=0;}
              f.append('send_invoice', self.form[prop]);
            }
            else if(prop == 'send_img'){
              if(self.form[prop]){self.form[prop]=1;}else{self.form[prop]=0;}
              f.append('send_img', self.form[prop]);
            }
            else{f.append(prop, self.form[prop]);}
          }
          if(self.validimg1==true){f.append('validimg1', 1);}
          else{f.append('validimg1', 0);}
          if(self.validimg2==true){f.append('validimg2', 1);}
          else{f.append('validimg2', 0);}
          if(self.validimgOld1==true){f.append('validimgOld1', 1);}
          else{f.append('validimgOld1', 0);}
          if(self.validimgOld2==true){f.append('validimgOld2', 1);}
          else{f.append('validimgOld2', 0);}
          f.append('folder_user', localStorage.getItem('folder_user'));
          if(self.form.ope == 'create')
          {

            window.billing.post('payments/create', f )
            .then((response) => {
                  //this.getInvoices();
                  this.searchFilter();
                  this.form.ref = null
                  this.form.numdoc = null
                  this.form.fecha = null
                  this.form.customer_id = null
                  this.form.id = null
                  this.form.invoice_id = null
                  this.form.memo = null
                  this.form.price = null
                  this.previewtotal = null
                  this.previewbalance = null
                  this.previewcustomername = null
                  this.previewcustomerlastname = null
                  this.previewcustomerbusinessname = null
     
                    this.$notify({
                      group: 'noti',
                      title: 'Success',
                      type: 'success',
                      text: 'Successful registration'
                    });
            
                  self.isLoading = false;
                  this.$modal.hide('modal-payment');
             }).catch((error) => {
                self.isLoading = false;
                console.log(error);
            });
          }

        },
      validP(){ 
        let vatIdRegex =  new RegExp(/^\d+(\.\d{0,2})?$/);
        //let vatIdRegex =  new RegExp(/^\d*(\.\d{1})?\d{0,1}$/)
        
        
        if(!vatIdRegex.test(this.form.price) && event.key!= '.'){
          this.form.vatError = true;          
          this.form.vatErrorMsg = "Enter the valid number, with a maximum of two decimal places.";
          this.botton=true;
        }
        else if(this.form.price == 0){  
          this.form.vatError = true;          
          this.form.vatErrorMsg = "Must be greater than zero."; 
          this.botton=true;
        }
        else if(this.totalinvoice != undefined && this.form.price > this.totalinvoice){  
          this.form.vatError = true;          
          this.form.vatErrorMsg = "Amount cannot be greater than the balance."; 
          this.botton=true;
        }
        else
        {
          this.form.vatError = false;
          this.botton=false;
          this.form.vatErrorMsg = ""; 
        }
      },
      getMethods(){
        var self = this;
        window.billing.get('paymentsmetodos')
        .then((response) => {
          let  Metodos = [];
          for(let item in response.data.result){
           Metodos.push({             
            value: response.data.result[item].id,
            text: response.data.result[item].name,
           }); 
          };
          self.PaymentMethodsList = Metodos;

        }).catch((error) => {
          console.log(error);
        });
      },
      fileImg1(event){
        this.form.img1 = event.target.files[0];
        this.validimg1 = true;
        this.Showimg1=true;
        if(event.target.files && event.target.files[0])
        {
          var reader = new FileReader();
          reader.readAsDataURL(event.target.files[0]);
          reader.onload = function (e) {
            document.querySelector("#img1").src=e.target.result;
          }
        }
      },
      fileImg2(event){
        this.form.img2 = event.target.files[0];
        this.validimg2 = true;
        this.Showimg2=true;
        if(event.target.files && event.target.files[0])
        {
          var reader = new FileReader();
          reader.readAsDataURL(event.target.files[0]);
          reader.onload = function (e) {
            document.querySelector("#img2").src=e.target.result;
          }
        }
      },
        getInvoices() {
              this.isLoading = true
            window.billing.get('invoices/' + window.localuserdata)
                .then((response) => {
                  console.log(response.data.result);
                    this.InvoicesList = response.data.result;
                    let e = this.InvoicesList;
                    for (var i = 0; i < e.length; i++) {
                      let fecdoc= new Date(e[i].fecdoc).toDateString();
                      let fn= fecdoc.split(' ');
                      this.InvoicesList[i].fecdoc=fn[1]+' '+fn[2]+', '+fn[3];
                      let fecdue= new Date(e[i].fecdue).toDateString();
                      fn= fecdue.split(' ');
                      this.InvoicesList[i].fecdue=fn[1]+' '+fn[2]+', '+fn[3];
                      let f_a= new Date();
                      fecdue= new Date(e[i].fecdue);
                      if(f_a > fecdue && e[i].idxstatus < 2 ){
                        this.InvoicesList[i].idxstatus = 4;
                      }
                    }
                    this.OldInvoicesList=this.InvoicesList;

					this.isLoading = false;
                }).catch((error) => console.log(error));
        },
        actionEmail(id,email,numdoc){
         this.$modal.show('modal-setting');
         this.SettingBox = 'modalEmail';
         this.DataMail.idinv = id;
         this.DataMail.IDitem = numdoc;
         this.DataMail.email = email;
         this.abrirCanalEventBus();
         //this.FormSendMail.EmailCheck = true
        },
        actionPdf(id){
            window.open(urlbase + "api/v2/invoice/pdf/" + id+'/'+localAccountID+'/'+localStorage.getItem('oauth_m') , "_blank");
        },
        actionPDFforEnvelope(id){
            window.open(urlbase + "api/v2/invoiceenvelopes/pdf/" + id+'/'+localAccountID+'/'+localStorage.getItem('oauth_m') , "_blank");
        },
        actionEdit(id){
            this.$router.push({name:'InvoiceDet', params:{idinv:id, edit: 'edit'}});
        },
         
        actionPrint(idinv){
          this.isLoading = true;
          window.billing.post('eprintinvo/' + idinv,{
            user_id : window.localuserdata,
            'eprint': 1
          }).then((response) => {
            console.log(response.data);
            this.isLoading = false;
            if(response.data.status){
              this.$notify({
                group: 'noti',
                title: 'Send!',
                type: 'success',
                text: 'Send Successful'
              });
            }else{
              this.$notify({
                group: 'noti',
                title: 'Send Mail!',
                type: 'error',
                text: 'Send error',
              });
            }
          }).catch((error) => {
            console.log(error);
            this.isLoading = false;
            this.$notify({
                group: 'noti',
                title: 'Send!',
                type: 'error',
                text: 'Send Error'
              });
          });
        },
        MetDeleteInvoice(idinv){
          this.isLoading = true
          this.$swal({
            title: "Delete this Invoice?",
            text: "Are you sure?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Yes, Delete it!"
                }).then((result) => {
                    if (result.value) {
                        window.billing.put('invoice/delete/' + idinv,{
                                user_id : window.localuserdata
                        }).then((response) => {
                            console.log(response.data);
                            this.isLoading = false;
                                if(response.data.status){
                                    //this.getInvoices();
                                    this.searchFilter();
                                     this.$notify({
                                          group: 'noti',
                                          title: 'Deleted!',
                                          type: 'success',
                                          text: 'Deleted Invoice Successful'
                                        });
                        
                                }
                        }).catch((error) => console.log(error,this.isLoading = false));
                    }
                });
      this.isLoading = false   
     },
      actionVoid(idinv){
        this.isLoading = true;
        this.$swal({
              title: "Void this Invoice?",
              text: "You will not be able to recover it",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Yes, Void it!",
              html: `<label>
                <input type="checkbox" value="1" id="sendNotiVoid">
                <span class="swal2-label">Send notification</span>
                </label>`
                  }).then((result) => {
                      if (result.value) {
                        let send = (document.querySelector('#sendNotiVoid').checked) ? 1 : 0;
                          window.billing.put('invoice/void/' + idinv,{
                                  user_id : window.localuserdata,
                                  send: send,
                          }).then((response) => {
                                  console.log(response.data);
                                  this.isLoading = false;
                                      if(response.data.status){
                                          //this.getInvoices();
                                          this.searchFilter();
                                          this.$notify({
                                          group: 'noti',
                                          title: 'Void!',
                                          type: 'success',
                                          text: 'Void Invoice Successful'
                                        });
                                   
                                      }
                                  }).catch((error) => console.log(error,this.isLoading = false));
                      }
           });
        this.isLoading = false ;

      },
     actionDuplicate(id){
      this.$router.push({name:'InvoicesNew', params:{idinv:id, duplicate: 'duplicate'}});
     },
     statement(id){
      this.$router.push('statement/'+ id + '')
     },
     convertRecurring(id){
      this.$router.push({name:'InvoiceRecConvert', params:{idinv:id, convert: 'convert'}});
     },
    },
    watch:{
        SettingBox: function (){
            if(!this.SettingBox ==''){
             this.$modal.show('hello-world');
            }
        },
        inputFilter: function(){
          this.searchFilter();
        }
    },
    computed :{
        Pending:  function () {
            return this.InvoicesList.filter(r => r.status === 1);
            //return this.requests.filter(r => r.status === "APPROVED");
        },
        Accepted:  function () {
            return this.InvoicesList.filter(r => r.status === 2);
        },
        Rejected:  function () {
            return this.InvoicesList.filter(r => r.status === 3);
        },
        Void:  function () {
            return this.InvoicesList.filter(r => r.status === 4);
        },
        datecreate : function (date) {
           return 'hola'
        },
        isDisabledCheck: function(){
        //return !this.FormSendMail.EmailCheck; 
       },
      isDisabled: function(){
        if(this.form.method_id == ''){
          return true;
        }
        else if(this.form.price == 0 || this.form.price == '' || this.form.price == null){
          return true;
        }
        else if(this.botton){
          return true;
        }
        else{return false; }
      },
    }
};
</script>
<style lang="scss" scoped>
.cdropdown ul li{padding: 3px 10px;}
.cdropdown ul li button{font-size: 0.760rem;}
#card-invoice{background: transparent;}
.dropdStatus{list-style:none;}
@media(max-width: 991px){
  .contenedor-invoice{
    width: 100%;
    overflow-x: scroll;
  }
}
.contenedor-invoice{background: #fff;}
.contenedor-invoice table{
  width: 100%;
  min-width: 767px;
  margin-bottom: 290px;
}
.contenedor-invoice table thead tr th,
.contenedor-invoice table tbody tr td{
  min-width: 40px;
}
#invoList {margin-bottom: 320px;}
#invoList tbody tr td{font-size: 0.775rem;}
#invoList thead tr th:nth-child(1), #invoList tbody tr td:nth-child(1){min-width: 60px;}
#invoList thead tr th:nth-child(2), #invoList tbody tr td:nth-child(2){min-width: 90px;}
#invoList thead tr th:nth-child(3), #invoList tbody tr td:nth-child(3){min-width: 90px;}
#invoList thead tr th:nth-child(4), #invoList tbody tr td:nth-child(4){min-width: 150px; }
#invoList thead tr th:nth-child(5), #invoList tbody tr td:nth-child(5){min-width: 150px; }
.contenedor-invoice table thead tr th{font-weight: bold;}
.paginacion{width: 70px;}
#invoList thead tr th:nth-child(11), #invoList tbody tr td:nth-child(11){ min-width: 70px; width: 70px; }

  @media(max-width: 1100px){
    #invoList thead tr th:nth-child(1), #invoList tbody tr td:nth-child(1){ min-width: 50px; }
    #invoList thead tr th:nth-child(2), #invoList tbody tr td:nth-child(2){ min-width: 80px; width: 80px; }
    #invoList thead tr th:nth-child(3), #invoList tbody tr td:nth-child(3){ min-width: 80px; width: 80px; }
    #invoList thead tr th:nth-child(4), #invoList tbody tr td:nth-child(4){ min-width: 150px; width: 150px; }
    #invoList thead tr th:nth-child(5), #invoList tbody tr td:nth-child(5){ min-width: 130px; width: 130px; }
    #invoList thead tr th:nth-child(6), #invoList tbody tr td:nth-child(6){ min-width: 90px; width: 90px; }
    #invoList thead tr th:nth-child(7), #invoList tbody tr td:nth-child(7){ min-width: 70px; width: 70px; }
    #invoList thead tr th:nth-child(8), #invoList tbody tr td:nth-child(8){ min-width: 90px; width: 90px; }
    #invoList thead tr th:nth-child(9), #invoList tbody tr td:nth-child(9){ min-width: 80px; width: 80px; }
    #invoList thead tr th:nth-child(10), #invoList tbody tr td:nth-child(10){ min-width: 50px; width: 50px; }
    #invoList thead tr th:nth-child(11), #invoList tbody tr td:nth-child(11){ min-width: 50px; width: 50px; }
    #invoList tbody tr td:nth-child(11) > .cdropdown > button{padding: 15px;}
    #invoList tbody tr td:nth-child(11) > .cdropdown > button:before{right: 11px;}
    #invoList tbody tr td:nth-child(11) > .cdropdown > button > span {display: none;}
    .contenedor-invoice {overflow-x: scroll; }
    .contenedor-invoice {max-width: 924px;}
  }
</style>
